// 异步导入
export default {
  // 导入组件
  asyncComponent(path) {
    return () =>
      import(/* webpackChunkName: "c-[request]" */ `@/components/${path}`)
  },
  // 导入页面
  asyncView(path) {
    return () => import(/* webpackChunkName: "v-[request]" */ `@/views/${path}`)
  }
}
